<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <material-card color="green" title="Get Quiz List By Params">
          <v-form ref="chapterFrom" v-model="valid" lazy-validation>
            <v-select
              :items="courseList"
              label="Select Course"
              item-text="name"
              item-value="id"
              v-model="question.course_id"
              class="mt-2"
              @change="onSelectCourse(question.course_id)"
              :rules="courseIDRules"
            ></v-select>
            <v-select
              clearable
              :items="courseSubjectList"
              label="Select Subject"
              item-text="name"
              item-value="subject_id"
              v-model="question.subject_id"
              class="mt-2"
              :rules="subject_IDRules"
              @input="onSelectSubject(question.course_id, question.subject_id)"
            ></v-select>
            <v-layout wrap>
            <v-flex sm10>
              <v-select
                clearable
                :items="chapterList"
                label="Select Chapter"
                item-text="name"
                item-value="id"
                v-model="question.chapter_id"
                class="mt-2"
                :rules="chapter_IDRules"
                @change="onSelectChapter(question.chapter_id)"
              ></v-select>
            </v-flex>
    <v-flex sm2 text-xs-right>
        <v-dialog :disabled="!question.subject_id" v-model="dialogChapter" width="1000" hegiht="auto" persistent>
          <template v-slot:activator="{ on }">
                <v-flex
                  xs12
                  md4
                >
            <v-btn
             :disabled="!question.subject_id"
              color="success"
              dark
              v-on="on"
            >
              Create Chapter
            </v-btn>
            
        </v-flex>
          </template>
          <v-card>
            <Form
              :Item="chapterItem"
              :Field="chapterInputFields"
              :Value="valueObj"
              @emitted="saveChapter"
              @closed="closeModal"
              />

          </v-card>
        </v-dialog>
        </v-flex>
        
        </v-layout>
      <v-layout wrap>
        <v-flex sm10>
            <v-select
            clearable
              :items="lecture_videoList"
              label="Select Lecture Video"
              item-text="title"
              item-value="id"
              v-model="question.lecture_id"
              class=""
              :rules="lecture_IDRules"
              @change="onSelectLecture(question.lecture_id)"
            ></v-select>
            
        </v-flex>
        
            <v-flex sm2 text-xs-right>
              
        <v-dialog :disabled="!question.chapter_id" v-model="lectureDialog" width="1000" hegiht="auto" >
          <template v-slot:activator="{ on }">
            
                <v-flex
                  xs12
                  md4
                >
            <v-btn :disabled="!question.chapter_id"
              color="success"
              dark
              v-on="on"
            >
              Create Lecture
            </v-btn>
                </v-flex>
          </template>

          <v-card>

            <FormLecture
              :ProgressBar="uploadPercentage"
              :DisableButton="disableButton"
              :Item="lectureItem"
              :Value="lectureValueObj"
              @emitted="submitLectureVideo"
              />

          </v-card>
        </v-dialog>
        </v-flex>
        </v-layout>
          </v-form>
        </material-card>
      </v-flex>
 
      <ExamList :AllExamList="allExams" v-if="question.subject_id" />
      
            <v-snackbar
              :color="color"
              :bottom="bottom"
              :top="top"
              :left="left"
              :right="right"
              v-model="snackbar"
              dark
            >
              <v-icon
                color="white"
                class="mr-3"
              >
                mdi-bell-plus
              </v-icon>
              <div> {{ noticeMessage }}</div>
              <v-icon
                size="16"
                @click="snackbar = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Form from "@/views/Form";
import ExamList from "@/views/ExamList";
import FormLecture from '@/views/FormLecture'
export default {
  metaInfo() {
    return {
      title: "Quiz | Admin"
    };
  },
  components: {
    Form,
    FormLecture,
    ExamList
  },
  computed: {
    ...mapState("course_subjects", [
      "courseList",
      "courseDetail",
      "subjectDetail",
      "courseSubjectList",
      "subjectListNotInCourse",
      "chapterList",
      "examList",
      "lecture_videoList",
      "examDetail",
      "question",
      "quiz_title",
      "uploadPercentage"
    ])
  },
  mounted() {
    this.getcourselist();
    this.getCourseSubjectList(this.$route.params.id);
    this.getCourseDetails(this.$route.params.id);
  },
  data() {
    return {
      panel: [false],
      valid: true,
      color: null,
      chapter: {},
      colors: ["warning"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackbar: false,
      headers: [
        {
          sortable: true,
          text: "Chapter",
          value: "name"
        }
      ],
      dialog: false,
      dialogChapter: false,
      lectureDialog: false,
      noticeMessage: "",
      valueObj: {},
      chapterNameRules: [
        v => !!v || "Chapter is required"
      ],
      subject_IDRules: [v => !!v || "Please select subject"],
      chapter_IDRules: [],
      quiz_IDRules: [v => !!v || "Please select quiz"],
      courseIDRules: [v => !!v || "Please select subject"],
      lecture_IDRules: [],

      item: {
        title: "Add new Question",
        subTitle: "This is the subtitle",
        width: "md6",
        submitText: "Submit"
      },
      valueObj: { },
      
      chapterItem: {
        'title': 'Create New Chapter',
        // 'subTitle': 'This is the subtitle',
        'width': 'md6',
        'submitText' : 'Submit'
      },
      chapterInputFields: [
        {
          label: 'Chapter Name',
          type: 'text',
          isEnable: true,
          name: 'name',
          formName: 'Chapter name',
          nameRules: [
            v => !!v || 'Chapter name is required',
            v => (v && v.length <= 190) || 'Chapter name must be less than 190 characters'
          ]
        },
        {
          label: 'Chapter Name Bangla',
          type: 'text',
          isEnable: true,
          name: 'name_bn',
          formName: 'Chapter name bangla',
          nameRules: [
            v => !!v || 'Chapter name Bangla is required',
            v => (v && v.length <= 190) || 'Chapter name Bangla must be less than 190 characters'
          ]
        },
        {
          label: 'Price',
          type: 'number',
          isEnable: true,
          name: 'price',
          formName: 'price',
          nameRules: [
            v => !!v || 'Price is required'
          ]
        }
      ],
      lectureItem: {
        'title': 'Add new Lecture Video',
        'subTitle': 'This is the subtitle',
        'width': 'md6',
        'submitText' : 'Submit'
      },
      lectureValueObj: {},
      allExams: [],
      disableButton: false
    };
  },
  created() {
    this.$store.state.course_subjects.question = {}
  },
  watch : {
      examList:function(val) {
        this.allExams = this.examList
      }
  },
  methods: {
    ...mapActions("course_subjects", [
      "fetchData",
      "CreateCourse",
      "getcourselist",
      "getCourseSubjectList",
      "getSubjectListNotInCourse",
      "addSubjectToCourse",
      "getCourseDetails",
      "getChapterNameListBySubjectId",
      "storeChapter",
      "getExamDetailById",
      "getLectureDetails",
      "storeLectureVideo",
      "getExamListByChapter"
    ]),
    getBackData(value) {
      console.log(this.question);
      console.log(value);
    },

    onSelectQuiz(quiz_id) {
      let obj = {
        course_id: this.question.course_id,
        subject_id: this.question.subject_id,
        chapter_id: this.question.chapter_id,
        lecture_id: this.question.lecture_id,
        quiz_id: quiz_id
      };
      this.getExamDetailById(obj);
    },
    onSelectChapter(chapter_id) {
      this.question.lecture_id = null;
      this.getExamListByChapter(chapter_id);
    },
    onSelectLecture(lecture_id) {
      if (this.question.lecture_id) {
        this.getLectureDetails(lecture_id);
      } else {
      let obj = {
        courseId: this.question.course_id,
        subjectId: this.question.subject_id
      };
      this.getChapterNameListBySubjectId(obj).then(response => {
        this.allExams = response.exams
      })
      }
    },
    onSelectCourse(course_id) {
      this.question.subject_id = null;
      this.$refs.chapterFrom.resetValidation();
      this.getCourseSubjectList(course_id);
    },
    onSelectSubject(course_id, subject_id) {
      this.question.chapter_id = null;
      this.question.lecture_id = null;
      this.$refs.chapterFrom.resetValidation();
      let obj = {
        courseId: course_id,
        subjectId: subject_id
      };
      this.getChapterNameListBySubjectId(obj).then(response => {
        this.allExams = response.exams
      })
    },

    saveChapter (obj) {
      let loader = this.$loading.show({
              color: "green",
              canCancel: true,
              onCancel: this.onCancel,
              loader: 'dots',
              isFullPage: true
            });
      obj.course_id = this.question.course_id
      obj.subject_id = this.question.subject_id
      if (this.$refs.chapterFrom.validate()) {
      this.storeChapter(obj).then(response => {
        if (response.status == "OK") {
          
          this.dialogChapter = false
          this.chapter.name = null
          this.$refs.chapterFrom.resetValidation()
          this.chapterList.push(response.result)
          this.color = "success";
          this.subject_id = null;
          this.noticeMessage = "Success! " + response.messages;
          this.snack("top");
          loader.hide()
        } else {
          this.color = "warning";
          this.noticeMessage = "Warning! " + response.messages;
          this.snack("top");
          loader.hide()
        }
      });
      } else {
      }
    },
    snack(...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }
      this.snackbar = true;
    },
    submitLectureVideo (data) {
      this.disableButton = true
  
      this.storeLectureVideo(data).then((response) => {
        if (response.status == 'OK') {
          this.lectureDialog = false
          this.disableButton = false
          this.$store.state.course_subjects.lecture_videoList.push(response.result)
          this.color= 'success'
          this.noticeMessage = response.messages
          this.snack('top')
        } else {
          this.noticeMessage = response.messages
          this.snack('top')
          this.lectureDialog = false
          this.disableButton = false
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    
    closeModal () {
      this.dialogChapter = false
    }
  }
};
</script>
